import React, { useContext } from "react"
import {
  Modal,
  ModalArticle,
  ModalAudio,
  ModalContent,
  ModalFigcaption,
  ModalFigure,
  ModalHeadline,
  ModalImage,
  MobileCloseModal
} from "./styles"
import Audio from '../Player/Audio'
import { AnimatePresence, motion } from "framer-motion"
import { GalleryModalContext } from "../../store/GalleryModalContext"
import SimpleBar from "simplebar-react"
import "simplebar/dist/simplebar.min.css"
import { isMobile } from "utils"

const FixedModal = ({ modal, closeModal }) => {

  const modalCtx = useContext(GalleryModalContext)

  return (
    <AnimatePresence>
      {modal && (
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.6 }}
          exit={{ x: "110%" }}
        >
          <Modal>
            {isMobile ? (
              <ModalArticle>
                <MobileCloseModal onClick={closeModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="52"
                    height="49"
                    version="1.1"
                    viewBox="0 0 52 49"
                  >
                    <path
                      fill="#fff"
                      fillOpacity="0"
                      stroke="#372b2b"
                      strokeLinecap="round"
                      strokeMiterlimit="20"
                      strokeWidth="2"
                      d="M23 20l9 9M23 29l9-9"
                    ></path>
                  </svg>
                </MobileCloseModal>
                <ModalHeadline>{modal?.title}</ModalHeadline>
                <ModalContent
                  dangerouslySetInnerHTML={{ __html: modal?.content }}
                ></ModalContent>
                {modal?.image && (
                  <ModalFigure>
                    <ModalImage src={modal?.image?.url} alt="" onClick={() => modalCtx.setGalleryModal(modal)} />
                    <ModalFigcaption>{modal?.image?.caption}</ModalFigcaption>
                  </ModalFigure>
                )}
                {(modal?.audio?.file || modal?.audio?.url) && (
                  <ModalAudio>
                    <Audio track={modal?.audio} color={"#23191c"} />
                  </ModalAudio>
                )}
              </ModalArticle>
            ) : (
              <>
                <svg
                  onClick={closeModal}
                  xmlns="http://www.w3.org/2000/svg"
                  width="52"
                  height="49"
                  version="1.1"
                  viewBox="0 0 52 49"
                  style={{
                    position: "absolute",
                    left: "-35px",
                    top: "15vh",
                    cursor: "pointer",
                  }}
                >
                  <path
                    fill="#df4a32"
                    d="M.762 44h45.8c1.6 0 2.9-1.3 2.9-2.9V6.9c0-1.6-1.3-2.9-2.9-2.9H.762c-.6 0-.9.6-.7 1.1l7 18.7c.1.2.1.4 0 .6l-7 18.7c-.2.3.1.9.7.9z"
                  ></path>
                  <path
                    fill="#fff"
                    fillOpacity="0"
                    stroke="#372b2b"
                    strokeLinecap="round"
                    strokeMiterlimit="20"
                    strokeWidth="2"
                    d="M23 20l9 9M23 29l9-9"
                  ></path>
                </svg>
                <SimpleBar style={{ height: "80vh", width: "100%" }}>
                  <ModalArticle>
                    <ModalHeadline>{modal?.title}</ModalHeadline>
                    <ModalContent
                      dangerouslySetInnerHTML={{ __html: modal?.content }}
                    ></ModalContent>
                    {modal?.image && (
                      <ModalFigure>
                        <ModalImage src={modal?.image?.url} alt="" onClick={() => modalCtx.setGalleryModal(modal)} />
                        <ModalFigcaption>{modal?.image?.caption}</ModalFigcaption>
                      </ModalFigure>
                    )}
                    {(modal?.audio?.file || modal?.audio?.url) && (
                      <ModalAudio>
                        <Audio track={modal?.audio} color={"#23191c"} />
                      </ModalAudio>
                    )}
                  </ModalArticle>
                </SimpleBar>
              </>
            )}
          </Modal>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default FixedModal
